export default __webpack_public_path__ + "static/media/questionTransparentBg.f4d91620.svg";